
// const hideValues = false

import ApiService from './ApiService'

class ReportService {

  acknowledgeCollaborator = async (apiToken, submissionId, status = true) => {
    var url = `/api/formsubmission/${submissionId}/acknowledge`

    var body = {
      status: status
    }
    var params = {}

    try {
      var response = await ApiService.post(apiToken, url, params, body)
    } catch (err) {
      console.error(err)
    }
    return response
  }

  getReport = async (apiToken, params, data) => {
    var url = '/api/report/generate'

    // var params = {}

    var body = {
      data: data
    }

    try {
      var response = await ApiService.post(apiToken, url, params, body)
    } catch (err) {
      console.error(err)
    }

    return response
  }
}
export default new ReportService()
